/**
 * Central error taxonomy. Every API failure carries one of these codes so the
 * client can render a Hebrew message without parsing prose.
 */
export const ErrorCodes = {
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  RATE_LIMITED: 'RATE_LIMITED',
  FORBIDDEN: 'FORBIDDEN',
  OUT_OF_SCOPE: 'OUT_OF_SCOPE',
  NOT_FOUND: 'NOT_FOUND',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  INVALID_JSON: 'INVALID_JSON',
  JSON_REQUIRED: 'JSON_REQUIRED',
  CONFLICT: 'CONFLICT',
  IN_USE: 'IN_USE',
  EMAIL_TAKEN: 'EMAIL_TAKEN',
  LAST_ADMIN: 'LAST_ADMIN',
  SELF_LOCKOUT: 'SELF_LOCKOUT',
  WRONG_PASSWORD: 'WRONG_PASSWORD',
  MFA_REQUIRED: 'MFA_REQUIRED',
  MFA_INVALID: 'MFA_INVALID',
  MFA_NOT_SET_UP: 'MFA_NOT_SET_UP',
  SCHEDULING_CONFLICT: 'SCHEDULING_CONFLICT',
  ALREADY_ASSIGNED: 'ALREADY_ASSIGNED',
  ROLE_TAKEN: 'ROLE_TAKEN',
  SCHEDULE_NOT_PUBLISHABLE: 'SCHEDULE_NOT_PUBLISHABLE',
  OVERRIDE_NOT_ALLOWED: 'OVERRIDE_NOT_ALLOWED',
  NOT_CONFIGURED: 'NOT_CONFIGURED',
  SCHEMA_NOT_READY: 'SCHEMA_NOT_READY',
  INTERNAL: 'INTERNAL',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
